import type { THomeSection, THomeSectionCustomSlider } from '~/layers/homepage/data/types'
import type { APIHomeSection } from '~/api/commonApi'
import { THomeSectionType } from '~/layers/homepage/data/types'
import { make as makeCollection } from '~/layers/homepage/data/adapters/homeSectionCollectionAdapter'
import getPoster from '~/layers/homepage/data/getPoster'

const DEFAULT_AUTOPLAY = 5000

const getTheme = (child:APIHomeSection) => {
  if (Array.isArray(child.configuration)) {
    return {
      isDark: true,
      isLight: false,
    }
  }

  return {
    isDark: Array.isArray(child.configuration) ? false : !!child.configuration.isDark,
    isLight: Array.isArray(child.configuration) ? false : !!child.configuration.isLight,
  }
}

export const make = (apiSection: APIHomeSection):(THomeSectionCustomSlider & THomeSection) | null => {
  return {
    type: THomeSectionType.CustomSlider,
    title: apiSection.caption,
    buttonText: apiSection.buttonText || '',
    link: apiSection.link || '',
    slides: apiSection.children.map(child => ({
      picture: child.images,
      video: Array.isArray(child.video)
        ? null
        : child.video,
      poster: getPoster(child),
      name: child.name,
      buttonText: child.buttonText || '',
      link: child.link || '',
      isSquad: Array.isArray(child.configuration) ? false : !!child.configuration.isSquad,
      ...getTheme(child),
    })),
    autoplay: Array.isArray(apiSection.configuration) || !apiSection.configuration.speed
      ? DEFAULT_AUTOPLAY
      : apiSection.configuration.speed * 1000,
    boxes: apiSection.children
      .map(child => {
        if (!child.title) {
          return null
        }
        const collection = makeCollection(child)
        return collection
          ? {
            ...collection,
            name: child.subtitle,
            title: child.title,
          }
          : null
      }),
  }
}